import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-12 md:mt-20 mb-8 text-center" }
const _hoisted_2 = { class: "mb-1 text-md font-bold leading-tight" }
const _hoisted_3 = { class: "text-base-200" }
const _hoisted_4 = { class: "max-w-[300px] w-full mx-auto mb-12 md:mb-20" }
const _hoisted_5 = { class: "text-center mt-4" }
const _hoisted_6 = {
  key: 0,
  class: "max-w-[520px] mx-auto"
}
const _hoisted_7 = { class: "text-info-900" }

import { AppConfigType, OptionType, ScheduleType } from '~src/admin/types';
import Select from '../form/Select.vue';
import { inject, ref } from 'vue';
import Button from '../base/Button.vue';
import IconArrowLeft from '../icons/IconArrowLeft.vue';
import TextInput from '../form/TextInput.vue';
import useGetLanguages from '~src/admin/composables/useGetLanguages';
import Card from '../layout/Card.vue';
import { useRouter } from 'vue-router';
import { useGettext } from 'vue3-gettext';

// Translations

export default /*@__PURE__*/_defineComponent({
  __name: 'ScheduleSettings',
  props: {
    schedule: {},
    isFirstSchedule: { type: Boolean }
  },
  emits: ["nextStep", "previousStep", "updateSchedule"],
  setup(__props: any, { emit: __emit }) {

const { $gettext } = useGettext();

// Get plugin config
const config: AppConfigType = inject('pluginConfig');

// Router
const router = useRouter();

// Props


// Emits
const emit = __emit;

// Author options
const authorOptions: OptionType[] = [
    ...config.wordpress.users.map((user) => {
        return {
            label: user,
            value: user,
        };
    }),
    {
        label: $gettext('Add new author'),
        value: 'new_author',
    },
];

// Languages for select
const languageOptions = useGetLanguages();

// Store values from inputs
const selectedAuthor = ref(__props.schedule.author || '');
const selecetedLanguage = ref<string>(__props.schedule.lang || '');
const newAuthorName = ref('');

// Show new author correctly
if (__props.schedule.author && !config.wordpress.users.includes(__props.schedule.author)) {
    selectedAuthor.value = 'new_author';
    newAuthorName.value = __props.schedule.author;
}

// Handle errors
const errorAuthor = ref('');
const errorLanguage = ref('');
const errorNewAuthor = ref('');

// Go to next step
const goToNextStep = () => {
    errorAuthor.value = '';
    errorLanguage.value = '';

    // Author validation
    if (!selectedAuthor.value) {
        errorAuthor.value = $gettext('Please select author.');
    }

    // New author validation
    if (selectedAuthor.value === 'new_author' && !newAuthorName.value) {
        errorNewAuthor.value = $gettext('Please provide author name.');
    }

    // Language validation
    if (!selecetedLanguage.value) {
        errorLanguage.value = $gettext('Please select language.');
    }

    if (errorAuthor.value || errorLanguage.value || errorNewAuthor.value) {
        return;
    }

    // Update the schedule
    const newSchedule = {
        ...__props.schedule,
        author: selectedAuthor.value === 'new_author' ? newAuthorName.value : selectedAuthor.value,
        lang: selecetedLanguage.value,
    };

    emit('updateSchedule', newSchedule);

    // Go to next step and update the schedule
    emit('nextStep');
};

// Set texts based on if schedule is first or not
let buttonText = $gettext('Save your first schedule');

if (!__props.isFirstSchedule) {
    buttonText = $gettext('Save schedule');
}

// Account type
const isAccountFree = inject<boolean>('isAccountFree');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref($gettext)('Who is the author?')), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref($gettext)('Choose author and language of your articles.')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(Select, {
        options: authorOptions,
        "error-msg": errorAuthor.value,
        placeholder: _unref($gettext)('Choose author...'),
        class: "mb-5",
        modelValue: selectedAuthor.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedAuthor).value = $event))
      }, null, 8, ["error-msg", "placeholder", "modelValue"]),
      (selectedAuthor.value === 'new_author')
        ? (_openBlock(), _createBlock(TextInput, {
            key: 0,
            placeholder: _unref($gettext)('Author\'s name'),
            "error-msg": errorNewAuthor.value,
            class: "mb-5",
            modelValue: newAuthorName.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newAuthorName).value = $event))
          }, null, 8, ["placeholder", "error-msg", "modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(Select, {
        options: _unref(languageOptions),
        "error-msg": errorLanguage.value,
        placeholder: _unref($gettext)('Choose language...'),
        class: "mb-8",
        modelValue: selecetedLanguage.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selecetedLanguage).value = $event))
      }, null, 8, ["options", "error-msg", "placeholder", "modelValue"]),
      _createVNode(Button, {
        class: "w-full",
        text: _unref($gettext)(_unref(buttonText)),
        size: "large",
        onClick: _withModifiers(goToNextStep, ["prevent"])
      }, null, 8, ["text"]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(Button, {
          text: _unref($gettext)('back to Date & time'),
          size: "small",
          "has-background": false,
          type: "secondary",
          "icon-position": "left",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('previousStep')), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createVNode(IconArrowLeft)
          ]),
          _: 1
        }, 8, ["text"])
      ])
    ]),
    (_unref(isAccountFree))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(Card, {
            "image-url": `${_unref(config).plugin_url}/public/images/first-schedule.png`,
            "image-alt": _unref($gettext)('Upgrade to premium plan')
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_7, [
                _createTextVNode(_toDisplayString(_unref($gettext)('On trial you can generate and publish only one article.')) + " ", 1),
                _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("a", {
                  href: "#",
                  class: "underline underline-offset-[3px]",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_unref(router).push('/upgrade')), ["prevent"]))
                }, _toDisplayString(_unref($gettext)('Upgrade')), 1),
                _createTextVNode(" " + _toDisplayString(_unref($gettext)('to paid plan to publish more of them.')), 1)
              ])
            ]),
            _: 1
          }, 8, ["image-url", "image-alt"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})